module.exports = __webpack_public_path__ + "static/media/rostick.042f6950.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DynamicContent/About/peopleCompany/rostick.png
// module id = 746
// module chunks = 0